import React from 'react'
import Slider from "react-slick"
import ReactPlayer from 'react-player'
import PDFV from './PdfView'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
const site = "https://api.guasasapo.cl";

const googleURL = "https://docs.google.com/uc?export=download&id="
const Galeria = ({ imagen = [], site, url, pdf, audiolink, forceVerticalFirst = false }) => {
    const [slideIndex, setSlideIndex] = React.useState(0);
    const zoomCycle = [1, 3, 7, 10, 7, 3];
    const [zoomStep, setZoomStep] = React.useState(0);

    const settings = {
        dots: true,
        infinite: true,
        speed: 350,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        beforeChange: (_, next) => {
            setSlideIndex(next)
            setZoomStep(0)
        },
    };

    if (pdf != null) {
        return (
            <div>
                <PDFV pdf={pdf}></PDFV>
            </div>
        )
    }
    if (url != null) {
        return (
            <ReactPlayer
                controls={true}
                url={url}
                config={{
                    vimeo: {
                        playerOptions: { playsinline: false, autoplay: true },
                    },
                }}
            />
        )
    }
    if (audiolink != null) {
        return (
            <div className="playergaleria">
                <AudioPlayer src={googleURL + audiolink} autoPlay />
            </div>
        )
    }

    const currentImage = imagen[slideIndex];
    const currentDownload = currentImage ? `${site}${currentImage.url}` : null;
    const isCurrentVertical = currentImage ? (currentImage.height || 0) > (currentImage.width || 0) : false;
    const useVerticalFrame = forceVerticalFirst && slideIndex === 0 ? true : isCurrentVertical;

    const viewerWidth = useVerticalFrame
        ? 'min(34vw, 500px)'
        : 'min(88vw, 1400px)';

    const viewerHeight = useVerticalFrame
        ? 'min(90vh, 1240px)'
        : 'min(84vh, 980px)';

    return (
        <div className="imgsliderc" style={{ width: viewerWidth, position: 'relative', transition: 'width 260ms ease, height 260ms ease' }}>
            {currentDownload ? (
                <a
                    href={currentDownload}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Descargar imagen"
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        width: '78px',
                        height: '78px',
                        background: '#000',
                        zIndex: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textDecoration: 'none',
                        boxShadow: '0 0 0 2px #000'
                    }}
                >
                    <div style={{ color: '#fff', fontSize: '9px', letterSpacing: '0.06em', textAlign: 'center', lineHeight: 1.15 }}>
                        ⬇<br />DESCARGAR
                    </div>
                </a>
            ) : null}
            <Slider {...settings} style={{ paddingLeft: "0" }}>
                {imagen.map(i => {
                    const isVertical = (i.height || 0) > (i.width || 0);
                    return (
                        <div className="imageContainer" key={i.url}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: viewerHeight, width: '100%', transition: 'height 260ms ease' }}>
                                <div style={{ width: useVerticalFrame ? 'min(34vw, 500px)' : 'min(84vw, 1320px)', height: viewerHeight, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'auto', transition: 'width 320ms ease, height 320ms ease' }}>
                                    <img
                                        src={site + i.url}
                                        alt={i.name}
                                        onClick={() => setZoomStep((step) => (step + 1) % zoomCycle.length)}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            maxWidth: '100%',
                                            maxHeight: '84vh',
                                            objectFit: 'contain',
                                            display: 'block',
                                            margin: '0 auto',
                                            cursor: zoomCycle[zoomStep] === 10 ? 'zoom-out' : 'zoom-in',
                                            transform: `scale(${zoomCycle[zoomStep]})`,
                                            transformOrigin: 'center center',
                                            transition: 'transform 220ms ease'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Slider>
        </div>
    )
}

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    paper: {
        position: "absolute",
        backgroundColor: "#151515",
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: "12px",
        width: "fit-content",
        maxHeight: "94vh",
        maxWidth: "94vw",
        outline: "none",
        transition: "width 320ms ease, height 320ms ease, max-width 320ms ease",
    },
}));
function SimpleModal({ nombre, descripcion, imagenm, imagenc, url, pdf, audiolink }) {
    const isPersa = nombre === 'Inauguración local persa';
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleClickAway = () => {
        setOpen(false);
    };

    return (
        <div className="cajaepisodio">
            {imagenm ? <img src={site + imagenm} alt={nombre} onClick={handleOpen}></img> : null}
            <h1>{nombre}</h1>
            <p>{descripcion}</p>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div style={{ ...modalStyle, transition: 'width 320ms ease, height 320ms ease' }} className={classes.paper}>
                    <ClickAwayListener onClickAway={handleClickAway}>
                        <div>
                            <Galeria pdf={pdf} imagen={imagenc} nombre={nombre} site={site} url={url} audiolink={audiolink} forceVerticalFirst={isPersa}></Galeria>
                        </div>
                    </ClickAwayListener>
                </div>
            </Modal>
        </div>
    );
}

export default SimpleModal
